import { Routes, Route } from 'react-router-dom';

// Landing pages
import LandingPage from './pages/LandingPage';

// Documentation pages
import DocsLayout from './layouts/DocsLayout';
import DocsOverview from './pages/docs/Overview';
import DocsQuickstart from './pages/docs/Quickstart';
import DocsAuthentication from './pages/docs/Authentication';
import DocsEnvironments from './pages/docs/Environments';
import DocsIntegrationGuide from './pages/docs/IntegrationGuide';
import DocsSessions from './pages/docs/Sessions';
import DocsWalletModes from './pages/docs/WalletModes';
import DocsWebhooks from './pages/docs/Webhooks';
import DocsApiOperators from './pages/docs/ApiOperators';
import DocsApiGames from './pages/docs/ApiGames';
import DocsApiAdmin from './pages/docs/ApiAdmin';
import DocsErrors from './pages/docs/Errors';
import DocsGamesDice from './pages/docs/GamesDice';
import DocsGamesPlinko from './pages/docs/GamesPlinko';
import DocsGamesCoinflip from './pages/docs/GamesCoinflip';
import DocsGamesCrash from './pages/docs/GamesCrash';
import DocsTestingGuide from './pages/docs/TestingGuide';
import DocsProvablyFair from './pages/docs/ProvablyFair';

export default function App() {
	return (
		<Routes>
			{/* Landing Page */}
			<Route path="/" element={<LandingPage />} />

			{/* Documentation */}
			<Route path="/docs" element={<DocsLayout />}>
				<Route index element={<DocsOverview />} />
				<Route path="quickstart" element={<DocsQuickstart />} />
				<Route path="authentication" element={<DocsAuthentication />} />
				<Route path="environments" element={<DocsEnvironments />} />
				<Route path="integration-guide" element={<DocsIntegrationGuide />} />
				<Route path="sessions" element={<DocsSessions />} />
				<Route path="wallet-modes" element={<DocsWalletModes />} />
				<Route path="webhooks" element={<DocsWebhooks />} />
				<Route path="api-operators" element={<DocsApiOperators />} />
				<Route path="api-games" element={<DocsApiGames />} />
				<Route path="api-admin" element={<DocsApiAdmin />} />
				<Route path="errors" element={<DocsErrors />} />
				<Route path="games-dice" element={<DocsGamesDice />} />
				<Route path="games-plinko" element={<DocsGamesPlinko />} />
				<Route path="games-coinflip" element={<DocsGamesCoinflip />} />
				<Route path="games-crash" element={<DocsGamesCrash />} />
				<Route path="testing-guide" element={<DocsTestingGuide />} />
				<Route path="provably-fair" element={<DocsProvablyFair />} />
			</Route>
		</Routes>
	);
}
